// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_heroSection__IYgM1 {
  background: radial-gradient(circle at 80% 20%, rgba(var(--brand-yellow-rgb), 0.15) 0%, rgba(9, 69, 203, 0.05) 50%, transparent 100%), var(--background-color0);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10.5rem 0 6rem 0;
  position: relative;
  overflow: hidden;
}

.styles_heroContent__eFjoU {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 2rem;
  width: 100%;
}

.styles_heroLogo__12gxv {
  width: 18rem;
  max-width: 80%;
  height: auto;
  margin: 0 auto 1rem auto;
  filter: drop-shadow(0 0 15px rgba(255, 255, 255, 0.1));
  transition: transform 0.3s ease;
}

.styles_heroLogo__12gxv:hover {
  transform: scale(1.03);
}

.styles_heroTitle__OpFIz {
  font-size: 3.5rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.15rem;
  line-height: 1.2;
}

.styles_goldText__B\\+lah {
  color: var(--brand-yellow);
}

.styles_textContrast__avxan {
  color: var(--text-color0);
}

.styles_heroSubtitle__UlFNe {
  font-size: 1.25rem;
  color: var(--text-color1);
  max-width: 40rem;
  margin: 0 auto;
  line-height: 1.6;
}

.styles_ctaScrollButton__iGVFt {
  margin-top: 1.5rem;
  background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-hover) 100%);
  color: #fff !important;
  font-weight: bold;
  padding: 1rem 3rem;
  border-radius: 5rem;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(var(--brand-yellow-rgb), 0.3);
  transition: all 0.3s ease;
}

.styles_ctaScrollButton__iGVFt:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(var(--brand-yellow-rgb), 0.5);
}

@media (max-width: 900px) {
  .styles_heroSection__IYgM1 {
    padding: 8rem 0 4rem 0;
    min-height: 100vh;
  }
  .styles_heroTitle__OpFIz {
    font-size: 2.5rem;
  }
  .styles_heroLogo__12gxv {
    width: 14rem;
  }
}

@media (max-width: 600px) {
  .styles_heroSection__IYgM1 {
    padding: 6.5rem 0 3rem 0;
    min-height: 100vh;
  }
  .styles_heroContent__eFjoU {
    gap: 1.25rem;
  }
  .styles_heroTitle__OpFIz {
    font-size: 2rem;
  }
  .styles_heroSubtitle__UlFNe {
    font-size: 1.1rem;
    padding: 0 1rem;
  }
  .styles_heroLogo__12gxv {
    width: 12rem;
  }
  .styles_ctaScrollButton__iGVFt {
    padding: 0.8rem 2rem;
    font-size: 0.95rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/public/CadastroLoja/components/HeroSection/styles.module.css"],"names":[],"mappings":"AAAA;EACE,8JAA8J;EAC9J,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,wBAAwB;EACxB,sDAAsD;EACtD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2FAA2F;EAC3F,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yDAAyD;EACzD,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF","sourcesContent":[".heroSection {\n  background: radial-gradient(circle at 80% 20%, rgba(var(--brand-yellow-rgb), 0.15) 0%, rgba(9, 69, 203, 0.05) 50%, transparent 100%), var(--background-color0);\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 10.5rem 0 6rem 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.heroContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 2rem;\n  width: 100%;\n}\n\n.heroLogo {\n  width: 18rem;\n  max-width: 80%;\n  height: auto;\n  margin: 0 auto 1rem auto;\n  filter: drop-shadow(0 0 15px rgba(255, 255, 255, 0.1));\n  transition: transform 0.3s ease;\n}\n\n.heroLogo:hover {\n  transform: scale(1.03);\n}\n\n.heroTitle {\n  font-size: 3.5rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.15rem;\n  line-height: 1.2;\n}\n\n.goldText {\n  color: var(--brand-yellow);\n}\n\n.textContrast {\n  color: var(--text-color0);\n}\n\n.heroSubtitle {\n  font-size: 1.25rem;\n  color: var(--text-color1);\n  max-width: 40rem;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.ctaScrollButton {\n  margin-top: 1.5rem;\n  background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-hover) 100%);\n  color: #fff !important;\n  font-weight: bold;\n  padding: 1rem 3rem;\n  border-radius: 5rem;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 4px 15px rgba(var(--brand-yellow-rgb), 0.3);\n  transition: all 0.3s ease;\n}\n\n.ctaScrollButton:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(var(--brand-yellow-rgb), 0.5);\n}\n\n@media (max-width: 900px) {\n  .heroSection {\n    padding: 8rem 0 4rem 0;\n    min-height: 100vh;\n  }\n  .heroTitle {\n    font-size: 2.5rem;\n  }\n  .heroLogo {\n    width: 14rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .heroSection {\n    padding: 6.5rem 0 3rem 0;\n    min-height: 100vh;\n  }\n  .heroContent {\n    gap: 1.25rem;\n  }\n  .heroTitle {\n    font-size: 2rem;\n  }\n  .heroSubtitle {\n    font-size: 1.1rem;\n    padding: 0 1rem;\n  }\n  .heroLogo {\n    width: 12rem;\n  }\n  .ctaScrollButton {\n    padding: 0.8rem 2rem;\n    font-size: 0.95rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroSection": `styles_heroSection__IYgM1`,
	"heroContent": `styles_heroContent__eFjoU`,
	"heroLogo": `styles_heroLogo__12gxv`,
	"heroTitle": `styles_heroTitle__OpFIz`,
	"goldText": `styles_goldText__B+lah`,
	"textContrast": `styles_textContrast__avxan`,
	"heroSubtitle": `styles_heroSubtitle__UlFNe`,
	"ctaScrollButton": `styles_ctaScrollButton__iGVFt`
};
export default ___CSS_LOADER_EXPORT___;
